import { css, html, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "./base/BaseElement";

@customElement("loading-element")
export class LoadingElement extends BaseElement {
  static styles = css`
    loading-element {
      display: flex;
      align-items: center;
      justify-content: center;

      box-sizing: border-box;
      position: absolute;
      z-index: 9999;
    }
    .configurator-loading {
      width: 100%;
      height: 100%;
    }
    .configurator-loading-item {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="%233a4a5b"></stop><stop offset=".3" stop-color="%233a4a5b" stop-opacity=".9"></stop><stop offset=".6" stop-color="%233a4a5b" stop-opacity=".6"></stop><stop offset=".8" stop-color="%233a4a5b" stop-opacity=".3"></stop><stop offset="1" stop-color="%233a4a5b" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(%23a12)" stroke-width="30" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="%233a4a5b" stroke-width="30" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg>');
      width: 50px;
      height: 50px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  `;

  private _resizeObserver?: ResizeObserver;

  connectedCallback(): void {
    super.connectedCallback();
    const host = this.getHostParent();
    if (host) {
      this._resizeObserver = new ResizeObserver(() => {
        this.style.width = host.offsetWidth + "px";
        this.style.height = host.offsetHeight + "px";
      });
      this._resizeObserver.observe(host);
      this.style.width = host.offsetWidth + "px";
      this.style.height = host.offsetHeight + "px";
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this._resizeObserver?.disconnect();
  }

  protected renderHtml(): TemplateResult {
    return html` <div class="configurator-loading-item"></div> `;
  }
}
